import { Component, Input } from '@angular/core';
import { TRUSTED_PARTNERS } from '@app/data/_index';
import { GoogleAnalyticsService } from '@app/services/_index';
import { logGoogleAnalytics } from '@app/utilities/_index';

@Component({
  selector: 'app-trusted-partners',
  templateUrl: './trusted-partners.component.html',
  styleUrls: ['./trusted-partners.component.scss'],
  standalone: false,
})
export class TrustedPartnersComponent {
  @Input() isLightMode = true; // Toggle to change background styling from light or dark
  trustedPartnersData = TRUSTED_PARTNERS.image;
  constructor(private googleAnalyticsService: GoogleAnalyticsService) {}

  /**
   * Send the query search label to Google Analytics
   * @param category - the source of the google analytics category string (ex. the page or component triggering the action)
   * @param action - the action to be (ex. click)
   * @param dataLabel - the label associated with the action
   */
  sendGoogleAnalytics(category: string, action: string, dataLabel: string): void {
    logGoogleAnalytics(category, action, dataLabel);
    this.googleAnalyticsService.sendEvent(category, action, dataLabel);
  }
}
